import React from "react";
import NavBar from "./Navbar";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <div style={{ overflowX: "hidden", maxWidth: "100%", width: "100%" }}>
      <NavBar />
      <div style={{ maxWidth: "1440px", margin: "0 auto", width: "100%", overflowX: "hidden" }}>
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
